import {getImageUrl, Sizes} from '@cohort/shared/utils/media';
import {classNames} from '@cohort/shared-frontend/utils/classNames';
import {isDark} from '@cohort/shared-frontend/utils/isDark';
import type {AccessesAndOwnership} from '@cohort/wallet/lib/Utils';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {styled} from 'styled-components';

const DigitalAssetVisualsGroupStyled = styled.div<{$backgroundColorCode: string}>`
  background-color: ${props => props.$backgroundColorCode};
  --tw-ring-opacity: 1;
  --tw-ring-color: ${props => props.$backgroundColorCode};
`;

interface OwnedDigitalAssetVisualsGroupProps {
  perkAccessesAndOwnerships: AccessesAndOwnership[];
  imageDominantColor: string | null;
  backgroundPageColorPage: string;
  hideVisualsOnMobile?: boolean;
  textStyle?: object;
}

export const OwnedDigitalAssetVisualsGroup: React.FC<OwnedDigitalAssetVisualsGroupProps> = ({
  perkAccessesAndOwnerships,
  imageDominantColor,
  backgroundPageColorPage,
  hideVisualsOnMobile,
  textStyle,
}) => {
  const {t} = useTranslation('components', {keyPrefix: 'ownedDigitalAssetVisualsGroup'});

  const maxDigitalAssetVisuals = 3;

  return (
    <div className="flex">
      <div
        className={classNames('isolate my-auto mr-2 flex', hideVisualsOnMobile && 'hidden md:flex')}
      >
        {perkAccessesAndOwnerships.slice(-maxDigitalAssetVisuals).map(accessesAndOwnership => {
          return (
            <DigitalAssetVisualsGroupStyled
              key={accessesAndOwnership.access.id}
              className="z-30 -mr-2 rounded-full ring-2 last:-mr-0"
              $backgroundColorCode={
                imageDominantColor !== null ? imageDominantColor : backgroundPageColorPage
              }
            >
              <DigitalAssetVisualsGroupStyled
                className={classNames('z-30 -mr-2 rounded-full ring-2 last:-mr-0')}
                $backgroundColorCode={
                  imageDominantColor !== null
                    ? imageDominantColor
                    : isDark(backgroundPageColorPage)
                      ? 'rgba(255, 255, 255, 0.05)'
                      : 'rgba(0, 0, 0, 0.05)'
                }
              >
                <img
                  className={classNames(
                    'relative h-[24px] w-[24px] min-w-[24px] rounded-full',
                    !accessesAndOwnership.access.canBeUsed && 'opacity-30'
                  )}
                  height={128}
                  width={128}
                  src={getImageUrl(
                    import.meta.env.COHORT_ENV,
                    accessesAndOwnership.ownership.digitalAsset.imageFileKey,
                    {
                      h: Sizes.S,
                      w: Sizes.S,
                    }
                  )}
                />
              </DigitalAssetVisualsGroupStyled>
            </DigitalAssetVisualsGroupStyled>
          );
        })}
      </div>
      <div
        className={classNames(
          'my-auto',
          imageDominantColor !== null && isDark(imageDominantColor)
            ? 'text-white/50'
            : 'text-black/50'
        )}
        style={textStyle}
      >
        {t('ownedNftCount', {
          count: perkAccessesAndOwnerships.length,
        })}
      </div>
    </div>
  );
};
OwnedDigitalAssetVisualsGroup.displayName = 'OwnedDigitalAssetVisualsGroup';
